export const t = (key: string, variables: Record<string, string | number> = {}): string => {
  const keys = key.split('.');
  let translation: any = window.themeTranslations;

  for (const k of keys) {
    if (translation?.[k]) {
      translation = translation[k];
    } else {
      console.warn(`Translation key '${key}' not found`);
      return key;
    }
  }

  // Replace variables in translation string
  if (typeof translation === 'string' && Object.keys(variables).length > 0) {
    return translation.replace(/\{\{\s*(\w+)\s*\}\}/g, (match, varName) => {
      return variables[varName] !== undefined ? String(variables[varName]) : match;
    });
  }

  return translation;
};
